import React from "react";
import { TextField, Box, Typography } from "@mui/material";
import InputMask from "react-input-mask";
import { RETRIEVE_REQUESTOR_FIELDS } from "./bondRetrieveSharedPropTypes";

const BondRetrievalRequestorInformation = ({ data, bondData, updateData, role, isDisabled }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    updateData({ ...data, [name]: value });
  };

  return (
    <Box
      className="bg-gray-100 p-6 rounded-lg shadow-md max-w-3xl mx-auto mt-8"
      sx={{ border: "1px solid #e0e0e0" }}
    >
      <Typography variant="h5" className="font-bold mb-4">
        Requestor Information
      </Typography>

      <Box className="grid grid-cols-1 gap-4">
        <TextField
          disabled={isDisabled}
          label="Name"
          name="firstName"
          value={data.firstName || ""}
          onChange={handleChange}
          fullWidth
          required
        />
        <TextField
          disabled={isDisabled}
          label="Email"
          name="email"
          value={data.email || ""}
          onChange={handleChange}
          fullWidth
          required
        />
        <InputMask
          mask="(999) 999-9999"
          value={data.phoneNumber || ""}
          onChange={handleChange}
          disabled={isDisabled}
        >
          {(inputProps) => (
            <TextField
              disabled={isDisabled}
              label="Phone Number"
              name="phoneNumber"
              value={data.phoneNumber || ""}
              onChange={handleChange}
              fullWidth
              required
            />
          )}
        </InputMask>
      </Box>
    </Box>
  );
};

BondRetrievalRequestorInformation.propTypes = RETRIEVE_REQUESTOR_FIELDS;

export default BondRetrievalRequestorInformation;
